/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, type MutationsObject } from '@kp/js-model';
import { Adresse } from '@/models/Adresse';
import { BaseModel } from '@/models/BaseModel';

export class AdressData extends BaseModel {
    adresse: Adresse | null = null;

    public mutations(): MutationsObject {
        return {
            adresse: (val: Adresse | null) => val ? createModel(Adresse, val) : null,
        };
    }
}
